import { Controller } from "@hotwired/stimulus"

// Updates the href of an a tag or src from a turbo-frame with an updated query string / url search param from input.
//
// source input element is from this.element, the element declaring data-controller='input-to-turbo-frame'
//
// updates every element (href or src) matching this.targetSelectorValue
//
// Connects to data-controller="input-to-turbo-frame"
export default class extends Controller {

	static values = {
		attributeName: String,
		targetSelector: String
	}

	connect() {
	}

	inputChanged(_event) {
		const attributeValue = this.element.value

		for (const element of document.querySelectorAll(this.targetSelectorValue)) {
			if (element.tagName == 'A') {
				this.setHrefAttribute(element, this.attributeNameValue, attributeValue)
			} else if (element.tagName == 'TURBO-FRAME') {
				this.setSrcAttribute(element, this.attributeNameValue, attributeValue)
			}
		}
	}

	setHrefAttribute(element, attributeName, attributeValue) {
		if (!element || !element.href) { return }

		const [path, params] = element.href.split('?')
		const searchParams = new URLSearchParams(params);
		if (attributeValue) {
			searchParams.set(attributeName, attributeValue)
		} else {
			searchParams.delete(attributeName)
		}
		element.href = `${path}?${searchParams.toString()}`
	}

	setSrcAttribute(element, attributeName, attributeValue) {
		if (!element || !element.src) { return }

		const [path, params] = element.src.split('?')
		const searchParams = new URLSearchParams(params);
		if (attributeValue) {
			searchParams.set(attributeName, attributeValue)
		} else {
			searchParams.delete(attributeName)
		}
		element.src = `${path}?${searchParams.toString()}`
	}

}
